import React, { Component } from 'react';
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../../core/reducers';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import './common.css'
import ReportContent from './content'
import { Button, message } from 'antd';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import Loading from "./Loading"
import { actionExportFeetStl } from '../../../../../core/actions/silizhu/report';

interface StateProps {
    reportDetail: any
}

interface DispatchProps {
    exportFeetStl(ticket: string): void
}

interface RouteProps {
    id: string
}

type PropsType = RouteComponentProps<RouteProps> & StateProps
class Index extends Component<PropsType & DispatchProps & WithTranslationProps> {

    state = {
        inExport: false
    }

    onSave = () => {
        const { inExport } = this.state
        this.setState({
            inExport: true
        })
        if (inExport) {
            return
        }
        let name = '';
        const i18n = this.props.i18n;
        let title = i18n?.t("silizhuReportTitle");
        let report = this.props.reportDetail;
        if (report.examinee) {
            name = report.examinee.nickname;
            title += '-' + name;
        }
        let that = this;
        // const reportTopHtml: any = document.getElementById('report-top');
        // let reportTopImg = '', reportTopWidth = 0, reportTopHeight = 0;

        // html2canvas(reportTopHtml, { allowTaint: true, useCORS: true }).then((canvas: any) => {
        //     reportTopWidth = canvas.width
        //     reportTopHeight = canvas.height
        //     reportTopImg = canvas.toDataURL('image/jpeg', 1.0)
        // })

        setTimeout(() => {
            html2canvas(
                document.getElementById('content_pdf_silizhu') as any,
                {
                    allowTaint: true,
                    useCORS: true,
                }
            ).then(function (canvas) {

                const contentWidth = canvas.width;
                const contentHeight = canvas.height;


                //一页pdf显示html页面生成的canvas高度;
                const pdfWidth =  595.28;
                const pdfHeight =  841.89;
                let pageHeight = contentWidth / pdfWidth * pdfHeight

                //未生成pdf的html页面高度
                let leftHeight = contentHeight

                //页面偏移
                let position = 0

                //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                let imgWidth = pdfWidth
                let imgHeight = pdfWidth / contentWidth * contentHeight

                const imgUrlData = canvas.toDataURL('image/jpeg', 1.0) // 添加配置项可压缩pdf文件大小

                const pdf = new jsPDF('p', 'pt', 'a4') as any


                setTimeout(() => {
                    // 当内容未超过pdf一页显示的范围，无需分页
                    if (leftHeight < pageHeight) {
                        pdf.addImage(imgUrlData, 'JPEG', 0, 0, imgWidth, imgHeight, '', 1)
                    } else {
                        while (leftHeight > 0) {

                            pdf.addImage(imgUrlData, 'JPEG', 0, position, imgWidth, imgHeight, '', 1)

                            // 添加报告头
                            // pdf.addImage(reportTopImg, 'JPEG', 0, 0, imgWidth, 592.28 / reportTopWidth * reportTopHeight, '', 1)

                            leftHeight = leftHeight - pageHeight
                            position = position - pdfHeight;
                            // position = position - 841.89 + (592.28 / reportTopWidth * reportTopHeight)

                            // console.log({ imgHeight }, { pageHeight }, { position }, { leftHeight });
                            //避免添加空白页
                            if (leftHeight > 0) {
                                pdf.addPage()
                            }
                        }
                    }
                    console.log('pdf生成成功！')
                    pdf.save(`${title}.pdf`)
                    that.setState({
                        inExport: false
                    })
                }, 1000);

            });
        }, 1000)

    }

    exportStl = (ticket) => {
        this.props.exportFeetStl(ticket)
    }

    render() {

        const location = window.location;
        const report = this.props.reportDetail || {};
        const header = report.header || {};

        const i18n = this.props.i18n;
        let language = i18n ? i18n.language : 'zh';
        let url = location.origin + '/silizhuReportDetail/' + header.ticket + '?language=' + language;

        const inExport = this.state.inExport;

        return (
            <div className="silizhuReportDetail model">
                <div className="content">
                    <div className="overflow-hidden btns">
                        <div className="right">
                            <Button
                                type="primary"
                                className="margin-right-12"
                                onClick={() => this.exportStl(header.ticket)}
                            >{i18n?.t('exportModel')}</Button>

                            <CopyToClipboard text={url} onCopy={() => message.success(i18n?.t('copySuccessfully'), 6)}>
                                <Button
                                    type="primary"
                                    className="margin-right-12"
                                >{i18n?.t('shareLink')}</Button>
                            </CopyToClipboard>
                            <Button
                                type="primary"
                                className="margin-right-12"
                                onClick={() => this.onSave()}
                            >{i18n?.t('savePdf')}</Button>
                           
                        </div>
                    </div>
                    <div id="content_pdf_silizhu">
                        <ReportContent inExport={inExport} />
                    </div>
                    {inExport && <Loading tip={`${i18n?.t('inExport')}...`} />}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        reportDetail: state.silizhuReport.reportDetail,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        exportFeetStl: (ticket: string) => {
            dispatch(actionExportFeetStl(ticket))
        }
    }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(Index)))